import { StateCreator } from 'zustand';
import { SettingsSlice } from './settings.types';

export const createSettingsSlice: StateCreator<
  SettingsSlice,
  [],
  [],
  SettingsSlice
> = () => ({
  paymentPoolingIntervals: null,
  emailValidationInterval: null,
  idwallPoolingIntervals: null,
});
